// @flow
import React from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { api_get, api_post } from "../../../utils/Api";
import { useState } from 'react';
import {
    Box,
    Card,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    makeStyles,
    TablePagination,
} from '@material-ui/core';
import Label from '../../../components/Label';
import Typography from "@material-ui/core/Typography";
import TablePaginationActions from 'components/Table/TablePaginationActions';



const useStyles = makeStyles(() => ({
    root: {
    },
}));

type Props = {
    histories: [
        {
            id: null,
            code_id: null,
            user_id: null,
            amount: 0,
            comment:  '',
            reference: '',
            status:  'pending' | 'ignored' | 'approuved' | 'active',
            created_at: null,
        },
    ],
    
    
    users: {
        meta: {total: number},
        data : Array<{id: number, user:{id: number, full_name: string, email: string }}>,
      },
}

const SegmentUsersInfo = (props: Props): React$Element<any> => {
    
    const {onPageChange,onChangeRowsPerPage,rowsPerPage,page,data, setData, values, ...rest} = props;
    const {className, users, meta} = props;
    const classes = useStyles();
   
    return (
        <Card
            className={clsx(classes.root, className)}
        >

            <CardHeader
                title="Segment Users"   
            />
            <Divider />
            <Box >
                <Table>
                    <TableHead>
                        <TableRow>
            
                            <TableCell>User ID</TableCell>
                            <TableCell>User Name</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Email</TableCell>
                           {/* <TableCell>Division</TableCell>*/}
                            <TableCell>Verified</TableCell>
                            <TableCell>Created At</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(users && users.length >0 )? (users.map((user, index) => (
                                <TableRow key={user.id}>
                                  
                                    <TableCell>
                                        {user.id}
                                    </TableCell>
                                  <TableCell>
                                        {user?.name+' '+user?.last_name}
                                    </TableCell>
                                    <TableCell>
                                        {user?.phone}
                                    </TableCell>
                                    <TableCell>
                                        {user?.email}
                                    </TableCell>
                                   {/*    <TableCell>
                                        {user?.division ? user.division : '---'}
                                    </TableCell>*/}
                                       <TableCell>
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            <Label color={user.verified === true ?
                                                'success' : 'error'}>
                                                {user.verified}
                                            </Label>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        {moment(user?.created_at).format('DD/MM/YYYY')}
                                        
                                    </TableCell>
                                </TableRow>
                            ))
                        ) :(
                            <TableRow >
                                <TableCell>
                                    Segment does not have any users
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Box>
         <TablePagination
                component="div"
                count={meta?.total}
                onPageChange={onPageChange}
                onChangeRowsPerPage={onChangeRowsPerPage}
                page={page-1}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[24, 48, 100]}
                ActionsComponent={TablePaginationActions}
            />     
        </Card>
    );
};


SegmentUsersInfo.propTypes = {
    className: PropTypes.string,
    histories: PropTypes.object.isRequired,
};

export default SegmentUsersInfo;
